module.exports = __webpack_public_path__ + "img/icon-msg.14695c45.svg";